<template>
	<div id="query">
  		<mt-header fixed :title="$t('交易查询')">
          	<mt-button icon="back" slot="left" onclick="window.history.go(-1)"></mt-button>
        </mt-header>
        <filter-bar  :bar-menus="barMenus" @showDialog="handleShowDialog" @closeDialog="handleCloseDialog" @changeTab="handleChangeTab" @changeMainItem="handleChangeMainItem" @changeSelect="changeData">
    	</filter-bar>

		<div class="content">
			<ul class="content_detail">
                <li  v-for="val in log">
                    <img v-bind:src="val.coin_icon" class="oImg">
					<span class="currency_name">{{val.type_msg}}</span>
					<div class="amount_of wx_rt">
						<p class="count wx_fontSize3">{{val.change | toThousandFilter}}</p>
					</div>
					<div class="clear"></div>
					<span class="left_lable">{{val.detial_type_msg}}</span>
					<span class="right_lable">{{val.ctime}}</span>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import { Swipe, SwipeItem } from 'mint-ui';
	import FilterBar from 'vue-filter-bar';
	import { httpGetMywealth,httpGetLog } from "@/api/wealth";
	export default{
		data:function() {  
		    return {
	    		log:{},
		    	barMenus:[{
				    name: this.$t('全部交易'),
				    icon: '',
				    value: 0,
				    showTabHeader: false,
				    defaultIcon: '',
				    selectIcon: '',
				    selectIndex: 0,
				    tabs: [{
				        icon: '',
				        name: '',
				        selectIndex: 0,
				        detailList: [{
				            name: this.$t('全部交易'),
				            icon: '',
				            value: 0,
				            selectIndex: 0
				        }, {
				            name: this.$t('划入'),
				            icon: '',
				            value: 1,
				            selectIndex: 1
				        }, {
				            name: this.$t('划出'),
				            icon: '',
				            value: 10,
				            selectIndex: 2
				        }, {
				            name: this.$t('增益收入'),
				            icon: '',
				            value: 20,
				            selectIndex: 2
				        }]
				    }]
				}, {
				    name: this.$t('全部产品'),
				    icon: '',
				    value: 0,
				    showTabHeader: false,
				    defaultIcon: '',
				    selectIcon: '',
				    selectIndex: 0,
				    tabs: [{
				        icon: '',
				        name: '',
				        selectIndex: 0,
				        detailList: [{
				            name: this.$t('全部产品'),
				            icon: '',
				            value: 0,
				            selectIndex: 0
				        }, {
				            name: this.$t('PoS挖矿'),
				            icon: '',
				            value: 1,
				            selectIndex: 1
				        }, {
				            name: this.$t('币计划'),
				            icon: '',
				            value: 2,
				            selectIndex: 2
				        }]
				    }]
				},{
				    name: this.$t('全部币种'),
				    icon: '',
				    value: 0,
				    showTabHeader: false,
				    defaultIcon: '',
				    selectIcon: '',
				    selectIndex: 0,
				    tabs: [{
				        icon: '',
				        name: '',
				        selectIndex: 0,
				        detailList: [{
				            name: this.$t('全部币种'),
				            icon: '',
				            value: 0,
				            selectIndex: 0
				        }]
				    }]
				}]
		    }  
	    }, 
	    activated(){
            this.getMywealth();
			this.getLog();
	    },
	    methods:{
			getLog: function() {
				httpGetLog({type:0,wealth_type:0,coin_id:0})
				.then(res => {
					this.log = res.data.list;
				})
				.catch(() => {});
			},
            getMywealth: function() {
                httpGetMywealth()
                .then(res => {
                	//console.log(res.data);
					var newArray = res.data.coin_symbols;
					//console.log(newArray.length);
					for (let i = 0; i < newArray.length; i++) {
						this.barMenus[2].tabs[0].detailList.push({
					            name: newArray[i].coin_symbol,
					            icon: '',
					            value: newArray[i].coin_id,
					            selectIndex: i
						});
					}
                	
                })
                .catch(() => {});
            },
			handleShowDialog(v) {
			// console.log(v);
			},
			handleCloseDialog(v) {
			// console.log(v);
			},
			handleChangeTab(v) {
			// console.log(v);
			},
			handleChangeMainItem(v) {
			// console.log(v)
			},
			changeData(v) {
				httpGetLog({type:v[0].value,wealth_type:v[1].value,coin_id:v[2].value})
				.then(res => {
					this.log = res.data.list;
				})
				.catch(() => {});
			},
			addressBook(){
				this.$router.push('/addressBook')
			}
		},
		components: {
			'filter-bar': FilterBar
		}

	}
</script>
<style lang="less" scoped>
#query{width:100%;height:100%;overflow: hidden;position: fixed;background:#f6f6f6;}
.header{width:100%;height:200px;position: relative;}
.mint-header{background: #ffffff;color:#212529;}
.header .bg{width:100%;height:100%;}
#query /deep/ .filterbar {
	.container{
	    width: 100%;
	    border-top: 1px solid #e3e8ed;
	    border-bottom: 1px solid #e3e8ed;
	    position: relative;
	    font-size: 14px;
	    color: #8c92a8;
	    .row .selected {
		    color: #1296db;
		}
		.row .col span {
		    background-image: url('../../assets/img/wealth/ico_wealth_xl.png');
		    width: 9px;
		    height: 7px;
		    display: inline-block;
		    background-size: 9px 7px;
		    background-repeat: no-repeat;
		}
		.col {
		    width: 80px;
		    text-align: center;
		}

	}
	.filterbarpop-wrap{
		.filterbarpop-bg {
	    	background: rgab(0, 0, 0, .6);
		}
		.filterbarpop{
			top: 40px;
			border:none;
		}
		.filterbarpop .main .line-style .item {
		    text-align: center;
		    margin: 0;
		    padding: 0;
		    border: 0;
		    position: relative;
		    color: #8c92a8;
		    span{
		    	margin: 0;
		    }
		}
		.filterbarpop .main{
			height: auto;
			padding: 15px;
			.line-style .item.selected {
				color: #1296db;
			}
		}
	}
}

/*内容*/
.content{
    background: #f6f6f6;
    width: 100%;
    padding-bottom: 15px;
    height: calc(100% - 114px);
    overflow: scroll;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: fixed;
    top: 80px;
    z-index: -1;
}
.local{padding-top:0;}
.content_detail{padding:0 15px 0 15px;}
.content_detail li{position: relative;width:100%;background:#fff;margin-top:12px;height: 78px;}
.oImg{
    width: 34px;
    height: 34px;
    margin: 15px 10px 5px 14px;
}
.currency_name{
	position: relative;
    top: -20px;
    font-size: 14px;
    font-weight: bold;
}
.amount_of{
    width: 44%;
    text-align: right;
    padding: 0 15px 0 0;
}
.count{color:#0191f5;padding:22px 0 10px 0;font-weight: bold;}
.money{color:#8c92a8;}

.block_list{width:100%; display: none;}
.block_list img{margin-top: 62px;width:264px;margin-left: calc(50% - 132px);}
.tip{color:#8c92a8;width:100%;text-align: center;position: relative;top:-40px;}
p{
	width: 100%;
}

.left_lable{
    font-size: 12px;
    margin: 0 0 0 58px;
    float: left;
    color: #a9afc8;
    line-height: 16px;
    position: absolute;
    bottom: 15px;
}
.right_lable{
	font-size: 12px;
    color: #8c92a8;
    position: absolute;
    bottom: 15px;
    right: 15px;
}
.clear{
	clear: both;
}
.filterbar{top:40px}
</style>
